import { render, staticRenderFns } from "./exchange_result.vue?vue&type=template&id=f438eabc&scoped=true&"
import script from "./exchange_result.vue?vue&type=script&lang=js&"
export * from "./exchange_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f438eabc",
  null
  
)

export default component.exports